import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../../shared/hooks';
import { useField } from '@unform/core';
import { ContaBancariaService } from '../services/api/Venda/ContaBancariaService';


type TAutoCompleteOption = {
  idconta: string;
  label: string;
}

interface IAutoCompleteContaProps {
  isExternalLoading?: boolean;
  name: string;
  label: string;
}

export const AutoCompleteContaBancaria: React.FC<IAutoCompleteContaProps> = ({ isExternalLoading = false, label }) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField('idconta');
  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    registerField({ 
      name: fieldName,
      getValue: () => selectedId, 
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);

  useEffect(() => {
    setIsLoading(true);
    debounce(() => {
      ContaBancariaService.getAllList(busca, selectedId?.toString())
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(conta => ({ idconta: conta.idconta, label: conta.numeroconta })));
          }
        });
    });
  }, [busca, selectedId, debounce]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idconta === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);


  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.idconta); setBusca(''); clearError(); }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label={label}
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};